import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { CommentCount } from 'components/UI/CommentCount';
import store from 'stores/RootStore';
import type TearsheetAd from 'stores/TearsheetAd';

const Container = styled.div`
  border-top: 1px solid #e9e9e9;
  display: flex;
  flex-direction: column;
`;

interface RowProps {
  $isActive?: boolean;
}

const Row = styled.div<RowProps>`
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 5px 8px;
  position: relative;
  transition: all 0.25s cubic-bezier(0.11, 0.61, 0.44, 0.99);

  &:hover {
    background-color: #f4f4f4;
  }

  ${(p) =>
    p.$isActive &&
    `
      background-color: #e1f3ff;
      font-weight: bold;
    `}
`;

function AdListTable() {
  const store_tearsheet = store.tearsheet;
  const tearsheetAdsManager = store_tearsheet?.ads;

  const handleRowOnClick = (targetAd: TearsheetAd) => {
    tearsheetAdsManager?.getById(targetAd.id)?.navigateTo();
  };

  return (
    <Container>
      {(tearsheetAdsManager?.children || []).map((ad) => (
        <Row
          $isActive={ad.active}
          key={ad.id}
          onClick={() => handleRowOnClick(ad)}
        >
          {ad.label || '···'}

          {ad.numComments > 0 && (
            <CommentCount
              isRead={ad.isRead}
              commentCount={ad.numComments}
              isCompactStyle
            />
          )}
        </Row>
      ))}
    </Container>
  );
}

export default observer(AdListTable);
